export class RegisterInputBillingToken {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "marketplaceToken",
            "baseName": "MarketplaceToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "marketplaceProvider",
            "baseName": "MarketplaceProvider",
            "type": "Provider",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RegisterInputBillingToken.attributeTypeMap;
    }
    constructor() {
    }
}
